import { Button } from '@optools/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@optools/components/ui/dropdown-menu';
import { ResourceTag } from '@optools/services/operator-gateway/types/generated/graphql';
import { Database, FileVideo, Tag } from 'lucide-react';
import { useEffect, useState } from 'react';

import { AuditTableFilter } from './audit-table-filter';

const TAG_OPTIONS = {
  gamePk: { icon: <Database />, title: 'Game PK' },
  mediaId: { icon: <FileVideo />, title: 'Media ID' },
};

export interface AuditTableResourceTagFilterProps {
  onChange: (value: ResourceTag | undefined) => void;
  tag: ResourceTag | undefined;
}

export function AuditTableResourceTagFilter({ onChange, tag }: AuditTableResourceTagFilterProps) {
  const [selectedFacet, setSelectedFacet] = useState<string | undefined>(undefined);

  // Reset the select to the default "Resource Tag" button when the filters are cleared externally
  useEffect(() => {
    setSelectedFacet(undefined);
  }, [tag]);

  const currentFacet = tag?.name ?? selectedFacet;

  if (currentFacet) {
    const { icon, title } = TAG_OPTIONS[currentFacet as keyof typeof TAG_OPTIONS];
    return (
      <AuditTableFilter
        defaultOpen={!!selectedFacet}
        icon={icon}
        title={title}
        value={tag?.value ?? ''}
        onChange={(value) => {
          const val = value ? { name: currentFacet ?? '', value } : undefined;
          onChange(val);
        }}
        onClose={() => {
          if (selectedFacet) setSelectedFacet(undefined);
        }}
      />
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="text-xs" size="sm" variant="outline">
          <Tag />
          Resource Tag
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="**:text-xs">
        {Object.entries(TAG_OPTIONS).map(([key, { icon, title }]) => (
          <DropdownMenuItem key={key} onSelect={() => setSelectedFacet(key)}>
            {icon}
            {title}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
